import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
export type KpiSource = 'vector' | 'raster';
@Injectable({
  providedIn: 'root',
})
export class KpiSidebarService {
private kpiDataSubject = new BehaviorSubject<{
    popupType: string | null;
    componentInputs: Record<string, any>;
    kpiSource: KpiSource | null;
    layerUUID?: string | null;
  }>({
    popupType: null,
    componentInputs: {},
    kpiSource: null,
    layerUUID: null
  });

  kpiData$ = this.kpiDataSubject.asObservable();
  public sidebarOpenSubject = new BehaviorSubject<boolean>(true);
  public sidebarWidth$ = new BehaviorSubject<number>(400);
  sidebarOpen$ = this.sidebarOpenSubject.asObservable();

  openSidebar() {
    this.sidebarOpenSubject.next(true);
  }


  expandSidebar(value: number) {
    this.sidebarWidth$.next(value);
  }
 showKPIComponent(
    popupType: string | null,
    componentInputs: Record<string, any>,
    kpiSource: KpiSource,
    layerUUID?: string | null
  ) {
    this.kpiDataSubject.next({ popupType, componentInputs, kpiSource, layerUUID });
    this.openSidebar();
  }
}
